import axios from 'axios';

import { API_URL } from "../constants";




export const PrivateApiCall = axios.create({
	baseURL: API_URL,
});

PrivateApiCall.interceptors.request.use(
	(req:any) => {
		const token = localStorage.getItem("access_token");
		req.headers.Authorization = `Bearer ${token}`;
		return req;
	},
	(err:any) => {
		throw err;
	}
);

PrivateApiCall.interceptors.response?.use(
	(res:any) => {
		return res;
	},
	(err:any) => {
		throw err;
	}
);

export const PublicApiCall = axios.create({
	baseURL: API_URL,
});

PublicApiCall.interceptors.request.use(
	(req:any) => {
		return req;
	},
	(err:any) => {
		throw err;
	}
);

PublicApiCall.interceptors.response?.use(
	(res:any) => {
		return res;
	},
	(err:any) => {
		throw err;
	}
);
